export default __webpack_public_path__ + "static/media/PuntoVerde.f99f3133.png";